export const sessionStorageGet = (key: string) => {
  return sessionStorage.getItem(key);
};
export const sessionStorageSet = (key: string, value: string) => {
  sessionStorage.setItem(key, value);
};
export const isEmpty = (val: Object) => {
  return Object.keys(val).length === 0;
};
